<template>
     <p id="demo"></p>
</template>
<script>
export default {
   
  name: 'RedirectComponent',
  mounted() {
    
    var str = window.navigator.userAgent;
    var str1 = "https://www.speedtest.net/"; // Default URL

    if (str.indexOf("Android") != -1) {
      str1 = "https://play.google.com/store/apps/details?id=org.zwanoo.android.speedtest&hl=vi";
      //https://play.google.com/store/apps/details?id=com.qr.vcard&pcampaignid=web_share
    } else if (str.indexOf("iPhone") != -1) {
      str1 = "https://apps.apple.com/vn/app/speedtest-by-ookla/id300704847?l=vi";
    }
    
    window.location.href = str1;
    console.log(str);
  }
}

</script>